import { GeneralTable } from "@/shared/components/ui";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Alert, Grid, Typography } from "@mui/material";
import { useFetchWorkOrder, useGetFlotaByUser } from "../actions/noc-module.actions";
import { OrdenTrabajoNoc } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import { useTableColumnsWorkOrder } from "../hooks/useTableColumnsWorkOrder";
import { useNavigate } from "react-router-dom";
import { ROUTER_PATHS } from "@/shared";
import { format } from "date-fns";

export default function TabOrdenTrabajoNocPendiente() {

    const navigate = useNavigate();
    const returnUrlOrdenTrabajoEditarPage = ROUTER_PATHS.noc.ordenesDeTrabajoNocNav;
    const username = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.username;
    const area = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.area;

    const { columnsWorkOrder } = useTableColumnsWorkOrder();

    const { pagination, setPagination } = useTableFilter();
    const { pageIndex, pageSize } = pagination;
    const { filterObject, columnFilters, setColumnFilters } = useTableServerSideFiltering();

    const { data: flotaUserRes } = useGetFlotaByUser(username) as any;
    const codigoFlota = flotaUserRes?.data;

    const {
        isLoading,
        data: workOrderRes,
        isRefetching
    } = useFetchWorkOrder({
        page: pageIndex,
        page_size: pageSize,
        orderStatus: 'PENDIENTE',
        ...(codigoFlota?.data.length > 0 && { fleetCode: codigoFlota?.data?.[0].codigo, dateOrder: format(new Date(), 'yyyy-MM-dd') }),
        ...filterObject,
    }, {
        enabled: !!codigoFlota,
    });

    const onEdit = (original: OrdenTrabajoNoc) => {
        if (codigoFlota?.data.length > 0) {
            navigate(`${returnUrlOrdenTrabajoEditarPage}/informe/${original.workOrderId}`);
        } else {
            navigate(`${returnUrlOrdenTrabajoEditarPage}/editar/${original.workOrderId}`);
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>

            </Grid>
            <Grid item xs={12}>
                {area == "TEC-01" && codigoFlota?.data.length <= 0 ?
                    <Grid item xs={12}>
                        <Alert severity="warning" sx={{ bgcolor: "warning.light" }}>
                            <Typography variant="body2">
                                <strong>Información:</strong> Por el momento no puede visualizar la información de actividades, por favor notificar a Desarrollo para su revisión.
                            </Typography>
                        </Alert>
                    </Grid>
                    :
                    <GeneralTable<OrdenTrabajoNoc>
                        columns={columnsWorkOrder}
                        data={workOrderRes?.data.content || []}

                        isLoading={isLoading}
                        isRefetching={isRefetching}
                        // // search
                        enableGlobalFilter={false}
                        // onGlobalFilterChange={setGlobalFilter}
                        // // pagination
                        pagination={pagination}
                        onPaging={setPagination}
                        rowCount={workOrderRes?.data?.totalElements}

                        ///* filters - server side
                        enableManualFiltering={true}
                        columnFilters={columnFilters}
                        onColumnFiltersChange={setColumnFilters}
                        enableSorting={false}

                        enableColumnActions={true}
                        positionActionsColumn='first'

                        // // actions
                        actionsColumnSize={120}
                        // crud
                        enableEditing={true}
                        onEdit={onEdit}

                        canDelete={false}
                    />
                }
            </Grid>
        </Grid>
    );
}